<template>
    <div class="page-center content-load">

        <div class="container">
            <div class="row">
                <div class="col-xl-4 col-md-6 col-lg-4 offset-xl-4 offset-md-3 offset-lg-4 animated fadeIn">

                    <center>
                        <span class="logo-mask">
                            <img src="static/images/logo.png" class="logo-sidebar">
                        </span>
                    </center>

                    <div class="login-register-page">
                        
                        <div class="welcome-text">
                            <h3 class="margin-bottom-10 margin-top-30">
                                <i class="las la-user-tie" style="font-size: inherit; top: 0px !important;"></i>
                                Plataforma Hidrobombas
                            </h3>
                        </div>
                            
                        <form method="post" id="login-form" v-on:submit.prevent="submit" novalidate="">
                            <div class="input-with-icon-left">
                                <i class="las la-at"></i>
                                <input type="email"  class="input-text with-border" autocomplete="new-password" name="email" id="email" placeholder="Informe seu e-mail" v-model="form.email" required/>
                            </div>

                            <div class="input-with-icon-left">
                                <i class="las la-lock"></i>
                                <input type="password" class="input-text with-border" autocomplete="new-password" name="senha" id="senha" placeholder="Informe sua senha" v-model="form.senha" required/>
                            </div>
                            <div class="mt-15">
                                <a v-on:click="recuperarSenha" class="forgot-password" v-bind:class="{'disabled': loading.recuperarSenha}" style="font-size: 14px;">Esqueceu sua senha?</a>
                            </div>
                            <button class="button button-lg color-secondary full-width margin-top-10" v-bind:class="{'disabled': loading.submit}" type="submit" form="login-form">
                                <i class="las la-lock"></i> 
                                Entrar
                            </button>
                        </form>

                    </div>

                </div>
            </div>
        </div>
    </div>      
</template>

<script>
export default {
    name: 'Login',
    data () {
        return {
            loading: {
                "recuperarSenha":   false,
                "submit":           false,
            },
            form: {
                "email":            "",
                "tipo":             "",
                "senha":            ""
            }
        }
    },
    methods: {
        recuperarSenha: function(e) {
            var self            = this;
            console.log("recuperarSenha", e, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.recuperarSenha = true;
            loading.show();
            axios.post("api/recuperar-senha.php", self.form)
            .then(response => {
                loading.hide();
                self.loading.recuperarSenha = false;
                console.log("ok", response)
                alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.recuperarSenha = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        submit: function(e) {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form));
            loading.show();
            if (e) e.preventDefault();
            self.loading.submit = true;
            form.senha          = md5(form.senha);

            axios.post("api/login.php", form)
            .then(response => {
                self.loading.submit = false;
                if (response.data.user) {                                 
                    self.$root.setUser(response.data.user).then(function() {
                        setTimeout(function() {
                            location.reload();
                        }, 500);
                    });
                } else {
                    loading.hide();
                }
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }        
    },
    mounted: function() {
        loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
    .page-login input {
        border: none !important;
    }

    .page-login #wrapper {
        /*background: rgba(255,255,255,0.8);*/
        background: transparent;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }    
    .current-page-login .loading {
        top: 0px !important;
    }
    .page-login #wrapper {
        /*background: rgba(255,255,255,0.7);*/
    }
    .page-login button {
        /*background: #0243BA !important;*/
    }

    .page-login button i {
        font-size: 20px;
        line-height: 100%;
        top: 2px !important;
        position: relative;        
    }

    .page-login .input-with-icon-left i {
        border-right: none !important;
    }
    .page-login .input-with-icon-left i {
        color: #333;
    }
    .page-login .container {
        padding-left: 20px;
        padding-right: 20px;
    }
    .logo {
        width: 220px;
        margin-bottom: 5vh;
    }
    .page-login .selo {
        /*position: absolute;*/
        bottom: 0px;
        width: 100%;
        display: block;
        margin-top: 5px;
        text-transform: uppercase;
        font-size: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
    }
   
</style>



// WEBPACK FOOTER //
// src/components/Login.vue